import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle, TextStyle, Image, View } from 'react-native';
import { ButtonProps } from './Buttons.types';
import { colorVariants } from './Button.styles';
import Typography from 'src/components/Text/Text';

const Button: React.FC<ButtonProps> = ({
  type = 'primary',
  size = 'big',
  colorVariant = 'default',
  title,
  onPress,
  disabled = false,
  style,
  icon,
  iconWidth,
  iconHeight,
  testID,
  tourId,
}) => {
  // Get the colors for the selected variant, select default/primary if unexpected type is passed.
  const selectedColors = colorVariants[colorVariant][type] || colorVariants.default.primary;

  // Define button styles based on size
  const buttonStyles: ViewStyle = {
    ...styles.button,
    height: size === 'big' ? 44 : 32,
    // width: size === 'big' ? 163 : 80,
    backgroundColor: selectedColors.backgroundColor,
    borderColor: selectedColors.borderColor, // Outline and tertiary buttons may have border
    ...style,
  };

  const textStyles: TextStyle = {
    ...styles.text,
    color: selectedColors.textColor,
  };

  return (
    <TouchableOpacity
      testID={testID}
      {...(tourId && { 'data-tour': tourId })}
      style={buttonStyles}
      onPress={onPress}
      disabled={colorVariant === 'disabled' ? true : disabled}>
      {icon ? (
        <View>
          <Image
            source={icon}
            style={[styles.iconContainer, { width: iconWidth, height: iconHeight }]}
          />
        </View>
      ) : null}
      <Typography variant="title3" style={textStyles}>
        {title}
      </Typography>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
  },
  text: {
    textAlign: 'center',
    textDecorationLine: 'none',
  },
  iconContainer: {
    width: 20,
    height: 20,
    marginRight: 8,
  },
});

export default Button;
